import { cancelSchedule, deleteSchedule, fetchSchedule, fetchScheduleFilter, fetchTimetableData } from 'actions/schedule'
import { Button, Modal, Typography } from 'antd'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { EventRegister } from 'react-native-event-listeners'
import { connect } from 'react-redux'
import PageDataLoader from 'components/pageDataLoader'
import modalIcon from 'Assets/schedule/modalIcon.svg'

const { Text } = Typography

// Scoped to "schedule-confirm-modal-v2" (in addition to the pre-existing
// "deleteModal" class, left in place for anything else relying on it) so this
// visual pass can't bleed into the unrelated "deleteModal" confirm used by
// digitalLibrary's own deleteConfirm.js, which shares that class name.
const confirmModalStyles = `
  body .schedule-confirm-modal-v2 {
    border-radius: 24px !important;
    overflow: hidden;
  }
  body .schedule-confirm-modal-v2 .ant-modal-content {
    border-radius: 24px !important;
    box-shadow: none !important;
  }
  body .schedule-confirm-modal-v2 .ant-modal-close {
    top: 16px !important;
    right: 16px !important;
  }
  body .schedule-confirm-modal-v2 .ant-modal-close-x {
    width: 48px !important;
    height: 48px !important;
    line-height: 48px !important;
    color: #AEAEAE !important;
    font-size: 16px !important;
  }
`;

if (typeof document !== 'undefined' && !document.getElementById('schedule-confirm-modal-v2-styles')) {
  const styleElement = document.createElement('style');
  styleElement.id = 'schedule-confirm-modal-v2-styles';
  styleElement.type = 'text/css';
  styleElement.appendChild(document.createTextNode(confirmModalStyles));
  document.head.appendChild(styleElement);
}



const DelConfirmModal = ({
    isModalVisible, setModalVisible, scheduleId, deleteSchedule, fetchSchedule, stdTimetable, tabType, fetchTimetableData, delOrCancel, cancelSchedule,
    currentDate, teacherSearch, classFilter, subFilter, fetchScheduleFilter,
    // Custom generic props for reuse
    customTitle, customSubtitle, onConfirm, customIcon
}) => {
    const [status, setStatus] = useState('')
    const [loading, setLoading] = useState(false)
    const handleCancle = () => {
        setModalVisible(false)
    }
    const handleDelete = async () => {
        if (onConfirm) {
            setLoading(true)
            try {
                await onConfirm();
            } finally {
                setLoading(false)
                setModalVisible(false)
            }
            return;
        }

        const isDelete = delOrCancel == 'deleteSchedule'
        if (!isDelete) setLoading(true)
        if (isDelete) {
            await deleteSchedule(scheduleId)
        }
        else if (delOrCancel == 'cancelOccurance') {
            await cancelSchedule(scheduleId)
        }
        EventRegister.emit('apicall:scheduleHome')
        if (tabType == "schedule") {
            if (currentDate === moment().format('DD MMM YYYY')) {
                fetchSchedule()
            }
            else {
                fetchScheduleFilter(currentDate ? moment(currentDate, ['DD MMM YYYY', 'DD/MM/YYYY', 'YYYY-MM-DD']).format('YYYY-MM-DD') : '', teacherSearch, classFilter, subFilter)
            }
        }
        else if (tabType == 'timetable') {
            fetchTimetableData(stdTimetable)
        }

        if (!isDelete) setLoading(false)
        setModalVisible(false)
    }
    useEffect(() => {
        if (delOrCancel == 'deleteSchedule') {
            setStatus('delete')
        }
        else if (delOrCancel == 'cancelOccurance') {
            setStatus('cancel')
        }
    }, [])
    return (
        <Modal
            className="deleteModal schedule-confirm-modal-v2"
            visible={isModalVisible}
            closable={true}
            maskClosable={true}
            footer={false}
            centered
            width={583}
            maskStyle={{ background: 'rgba(0,0,0,0.25)' }}
            bodyStyle={{ padding: '32px 40px', minHeight: 416 }}
            onCancel={() => handleCancle()}
        >
            <div className="deleteModal-content">
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    <img src={customIcon || modalIcon} alt="confirm icon" style={{ width: 120, height: 120, marginBottom: 28 }} />
                    <Text style={{ textAlign: 'center', color: '#191919', fontWeight: 500, fontFamily: 'roboto', fontSize: '24px' }}>{customTitle || `Confirm to ${status}?`}</Text><br></br>
                    {customSubtitle ?
                        <Text style={{ textAlign: 'center', color: '#636363', fontFamily: 'roboto', fontSize: '16px', maxWidth: 440, display: 'inline-block', marginTop: 20 }}>{customSubtitle}</Text>
                        : status == 'delete' ?
                            <Text style={{ textAlign: 'center', color: '#636363', fontFamily: 'roboto', fontSize: '16px', maxWidth: 440, display: 'inline-block', marginTop: 20 }}>{` Are you sure you want to delete the schedule?`}</Text>
                            :
                            <Text style={{ textAlign: 'center', color: '#636363', fontFamily: 'roboto', fontSize: '16px', maxWidth: 440, display: 'inline-block', marginTop: 20 }}>{`Are you sure you want to cancel the class for the chosen date?`}</Text>}
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: 25, marginTop: '64px' }}>
                    <Button
                        type='default'
                        style={{ width: 223, height: 45, borderRadius: 12, border: '1px solid #AEAEAE', color: '#AEAEAE', fontWeight: 700, fontSize: 16 }}
                        onClick={() => handleCancle()}
                    >NO</Button>
                    <Button
                        type='primary'
                        style={{ width: 223, height: 45, borderRadius: 12, border: 'none', background: '#594099', color: '#FFFFFF', fontWeight: 700, fontSize: 16 }}
                        onClick={() => handleDelete()}
                    >YES</Button>
                </div>
            </div>
            <PageDataLoader visible={loading} />
        </Modal>
    )
}

const mapStateToProps = (state) => {
    const {
        scheduleId,
        tabType,
        stdTimetable,
        currentDate,
        teacherSearch,
        classFilter,
        subFilter
    } = state.schedule;
    return {
        scheduleId,
        tabType,
        stdTimetable,
        currentDate,
        teacherSearch,
        classFilter,
        subFilter
    };
};

const mapDispatchToProps = (dispatch) => ({
    deleteSchedule: (id) => dispatch(deleteSchedule(id)),
    fetchSchedule: () => dispatch(fetchSchedule()),
    fetchTimetableData: (stdTimetable) => dispatch(fetchTimetableData(stdTimetable)),
    cancelSchedule: (id) => dispatch(cancelSchedule(id)),
    fetchScheduleFilter: (date, topic, std, sub) => dispatch(fetchScheduleFilter(date, topic, std, sub))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps

)(DelConfirmModal);

// export default DelConfirmModal